/* eslint-disable camelcase */
import { eventKeyCodes } from '../helpers/eventKeyCodes';
import { pushToDataLayer } from '../analytics/pushToDataLayer';
import { convertUrlToAbsolute } from '../helpers/convertUrlToAbsolute';
import { isMobile } from '../helpers/isMobile';
import { SearchSuggestions } from './searchSuggestions';

export class SiteSearch {
  constructor() {
    this.searchTerm = '';
    this.searchPageUrl = $('.js-site-search-url').data('search-page-url');
    this.searchQueryValue = '';
    this.headerSearchInput = $('.js-search-header .js-input-site-search');
    this.searchPlaceholderLength = this.headerSearchInput.attr('placeholder')?.length || 0;
    this.addEvents();

    if ($('.js-input-search-main').length > 0) {
      $('.site-search-page .js-btn-site-search').attr('disabled', $('.js-input-search-main').val().length === 0);
      this.searchQueryValue = $('.js-input-search-main').val();
    }

    if (!isMobile() && this.searchPlaceholderLength > 0) {
      this.headerSearchInput.attr('size', this.searchPlaceholderLength - 1);
    }

    this.headerSearchInput.attr('tabindex', '-1');

    this.headerSearchSuggestions = new SearchSuggestions($('.js-search-header'), this.headerSearchInput);

    if ($('.js-input-search-main').length > 0) {
      this.mainSearchSuggestions = new SearchSuggestions($('.site-search-page'), $('.js-input-search-main'));
    }
  }

  static isOnPage() {
    return document.getElementsByClassName('js-site-search-url').length > 0;
  }
  /**
   * Used to increase width of input search on desktop devices
   * Also when the focus is shifted to the input field and overlay appears over main background
   * @param {Object} event
   */
  onSearchInputFocus(event) {
    if ($(event.currentTarget).closest('.js-search-header').length > 0) {
      $('.js-header-logo').addClass('u-disableLink');
      $('.js-search-overlay').addClass('u-display-none');
      $('.js-search-header').addClass('site-search-box--is-expanded');

      if (innerWidth > 992) {
        $('.links-container-wrapper').addClass('u-display-none');
      }

      $('.js-collapse-search-header').removeClass('u-display-none');
      $('.header').addClass('header-search-expanded');

      this.headerSearchInput.attr('tabindex', '0');

      if ($('.js-overlay-search-bg').length === 0) {
        let headerHeight = $('.header-search-expanded').height();
        $('body')
          .addClass('u-overflow-hidden')
          .prepend(`<div class="overlay-search-bg js-overlay-search-bg" style="top: ${headerHeight}px;"></div>`);
      }

      setTimeout(() => {
        this.headerSearchInput.trigger('focus');

        if (this.headerSearchInput.val().trim().length > 0 && this.headerSearchSuggestions) {
          this.headerSearchSuggestions.fetchSuggestions(this.headerSearchInput.val().trim());
        }
      }, 0);
    }
  }

  /**
   * Used for collapse input search wrapper on desktop devices
   * Hide overlay on btn close icon
   * Reset search result and enable search button
   * @param {Object} event
   */
  onSearchDeactivateFromHeader(event) {
    this.searchTerm = '';

    if ($(event.currentTarget).hasClass('js-collapse-search-header')) {
      this.collapseSearchHeader();
    }

    $('.js-header-logo').removeClass('u-disableLink');
    $('.js-btn-site-search').prop('disabled', false);

    if (this.headerSearchSuggestions) {
      this.headerSearchSuggestions.hideSuggestions();
    }
  }
  /**
   * Add value to search input variable
   * Added keyboard events to redirect/close input field
   * @param {Object} event
   */
  onSearchTermChange(event) {
    this.searchTerm = event.target.value;

    $(event.currentTarget.classList.contains('js-input-search-header')
      ? '.js-reset-search-header'
      : '.js-reset-search-main'
    ).toggleClass('u-display-none', this.searchTerm.length === 0);

    // Redirect action on pressed enter key on keyboard
    if (event.which === eventKeyCodes.enter) {
      this.onSearch();
    }

    // Close search input field on pressed escape key on keyboard
    if (event.which === eventKeyCodes.escape) {
      if ($(event.target).hasClass('js-input-search-header')) {
        this.collapseSearchHeader();
        $('.js-search-header .js-btn-site-search').trigger('focus');

        if (this.headerSearchSuggestions) {
          this.headerSearchSuggestions.hideSuggestions();
        }
      } else {
        this.searchTerm = '';
        $(event.target).val('');
        $(event.target).siblings('.js-reset-search-main').addClass('u-display-none');
        $(event.target).siblings('.js-btn-site-search').prop('disabled', true);

        if (this.mainSearchSuggestions) {
          this.mainSearchSuggestions.hideSuggestions();
        }
      }
    } else {
      $(event.target).siblings('.js-btn-site-search').prop('disabled', false);
    }
  }

  /**
   * Redirect action on pressed enter key on keyboard
   */
  onSearch() {
    const currentInputValue = $('.js-search-header.site-search-box--is-expanded .js-input-site-search').val()
      || $('.js-input-search-main').val()
      || this.searchTerm;

    window.location.href = `${this.searchPageUrl}?q=${encodeURIComponent(currentInputValue || '')}`;
  }

  /**
   * Navigate to new page using href passed from value of an option element
   * @param {Object} event
   */
  onMobileTabChange(event) {
    window.location.href = $(event.currentTarget).val();
  }
  /**
   * A method for resetting individual search input fields,
   * depending on the parameters that determine which search input field will be reset
   * @param {Event} event
   * @param {Boolean} isHeader
   */
  resetInputField(event, isHeader) {
    this.searchTerm = '';
    const inputSelector = isHeader ? '.js-input-search-header' : '.js-input-search-main';
    const resetButtonSelector = isHeader ? '.js-reset-search-header' : '.js-reset-search-main';
    const searchButtonSelector = isHeader ? '.js-search-header .js-btn-site-search' : '.js-site-search-page .js-btn-site-search';

    $(inputSelector).val('');
    $(resetButtonSelector).addClass('u-display-none');
    $(searchButtonSelector).prop('disabled', false);

    // Hide suggestions when input is reset
    if (isHeader && this.headerSearchSuggestions) {
      this.headerSearchSuggestions.hideSuggestions();
    } else if (!isHeader && this.mainSearchSuggestions) {
      this.mainSearchSuggestions.hideSuggestions();
    }

    setTimeout(() => {
      $(inputSelector).trigger('focus');
    }, 0);
  }

  /**
   *  Closing search and adding overlay background to body
   */
  collapseSearchHeader() {
    this.searchTerm = '';
    $('.js-input-search-header').val('');
    $('.js-collapse-search-header').addClass('u-display-none');
    $('.js-reset-search-header').addClass('u-display-none');
    $('.js-search-overlay').removeClass('u-display-none');
    $('.js-search-header').removeClass('site-search-box--is-expanded');
    $('.links-container-wrapper').removeClass('u-display-none');
    $('.js-overlay-search-bg').remove();
    $('body').removeClass('u-overflow-hidden');
    $('.js-search-header .js-btn-site-search').prop('disabled', false);
    $('.header').removeClass('header-search-expanded');

    this.headerSearchInput.attr('tabindex', '-1');

    if (this.headerSearchSuggestions) {
      this.headerSearchSuggestions.hideSuggestions(); 
    }
  }

  /**
   * Hide search on when is clicked anywhere outside the element
   * @param {Object} event
   */
  clickOutsideSearchElement(event) {
    if (!$(event.target).closest('.header').length && $('.js-search-header').hasClass('site-search-box--is-expanded')) {
      this.collapseSearchHeader();
    }
  }

  /**
   * When the user navigates away the search by using the tab key collapse the search header and
   * focus the next item in the header manually to fix skipping .header-items links.
   * @param {Object} event
   */
  onFocusOutCollapseBtn(event) {
    const relatedTarget = event.relatedTarget;
    if (!$(relatedTarget).closest('.js-search-header').length) {
      this.collapseSearchHeader();
    }
  }

  onSearchDeactivateKeyup(event) {
    if (event.which === eventKeyCodes.enter) {
      this.onSearchDeactivateFromHeader(event);
    }
  }

  /**
   * Calculate total number of search results.
   * @returns {Number}
   */
  calculateTotalSearchResults() {
    return $('.search-result-filter-item-text').toArray().reduce((total, element) => {
      const match = $(element).text().match(/\d+/);

      return match ? total + parseInt(match[0], 10) : total;
    }, 0);
  }

  /**
   * Related to tracking google analytics.
   * Tracks the value that was searched and total number of search results.
   * @param {String} searchTerm
   * @param {Number} totalSearchResults
   */
  searchEvents() {
    const searchTerm = $('.js-input-search-main').val();
    const totalSearchResults = this.calculateTotalSearchResults();

    if (searchTerm) {
      pushToDataLayer({
        event: 'ga4_view_search_results',
        ga4_data: {
          search_term: searchTerm,
          search_results_count: totalSearchResults
        }
      });
    }
  }

  /**
   * Related to tracking google analytics.
   * Tracks the total number of search results, and the value that was searched,
   * the text of the clicked element and the URL of the link the user clicked on.
   * @param {Object} event
   * @param {String} searchTerm
   * @param {Number} totalSearchResults
   */
  clickOnSearchResultItem(event, searchTerm, totalSearchResults) {
    const $target = $(event.currentTarget);
    const targetUrl = convertUrlToAbsolute($target.data('url'));
    let clickedText;

    if ($target.hasClass('ga-product-click')) {
      clickedText = $target.find('.title').text().trim();
    } else if ($target.hasClass('ga4-search-result')) {
      clickedText = $target.find('.search-article-title').text().trim();
    } else {
      clickedText = $target.text().trim();
    }

    pushToDataLayer({
      event: 'ga4_select_search_results',
      ga4_data: {
        search_term: searchTerm,
        search_results_count: totalSearchResults,
        link_url: targetUrl,
        link_text: clickedText
      }
    });
  }

  addEvents() {
    $('.js-search-header, .js-input-site-search').on('keydown', event => {
      const isHeaderSearch = $(event.target).closest('.js-search-header').length > 0;

      if (event.which === eventKeyCodes.space) {
        if (isHeaderSearch) {
          const isExpanded = $('.js-search-header').hasClass('site-search-box--is-expanded');

          if (!isExpanded) {
            event.preventDefault();
          }
        }
      }
    });

    $('.js-search-header, .js-input-site-search').on('click keyup mousedown', event => {
      const $searchHeader = $('.js-search-header');
      const isExpanded = $searchHeader.hasClass('site-search-box--is-expanded');

      if (isExpanded) {
        return;
      }

      const isClickOnSearchButton = (event.type === 'click' || event.type === 'mousedown') && $(event.target).closest('.js-btn-site-search').length > 0; 
      const isClickOnInput = (event.type === 'click' || event.type === 'mousedown') && $(event.target).is('.js-input-site-search');
      const isClickOnHeaderContainer = event.type === 'click' && $(event.target).is('.js-search-header');
      const isEnterPressed = event.type === 'keyup' && event.which === eventKeyCodes.enter;
      const isSpacePressed = event.type === 'keyup' && event.which === eventKeyCodes.space;

      if (isClickOnSearchButton || isClickOnInput || isClickOnHeaderContainer || isEnterPressed || isSpacePressed) {
        if (isEnterPressed || isSpacePressed) {
          event.preventDefault();
        }
        this.onSearchInputFocus(event);
      }
    });

    $('.js-search-header .js-btn-site-search').on('click', (event) => {
      const $searchHeader = $('.js-search-header');
      const $button = $(event.currentTarget);

      if ($searchHeader.hasClass('site-search-box--is-expanded')) {
        event.preventDefault();
        event.stopPropagation();

        if (!$button.prop('disabled')) {
          this.onSearch();
        }
      }
    });

    this.headerSearchInput.on('keydown input', event => this.onSearchTermChange(event));
    $('.js-input-search-main').on('keydown input', event => this.onSearchTermChange(event));

    $('.js-collapse-search-header').on('click keyup', event => {
      if (event.type === 'click' || (event.type === 'keyup' && event.which === eventKeyCodes.enter)) {
        event.preventDefault();
        this.onSearchDeactivateFromHeader(event);
      }
    });

    $('.js-collapse-search-header').on('focusout', event => this.onFocusOutCollapseBtn(event));

    $('.js-reset-search-header, .js-reset-search-main').on('click keydown', event => {
      if (event.type === 'click' || (event.type === 'keydown' && event.which === eventKeyCodes.enter)) {
        event.preventDefault();
        let isHeader = $(event.currentTarget).hasClass('js-reset-search-header');
        this.resetInputField(event, isHeader);
      }
    });

    $(document).on('click.siteSearch', event => this.clickOutsideSearchElement(event));

    $(document).on('keydown.siteSearch', event => {
      if (event.which === eventKeyCodes.escape && $('.js-search-header').hasClass('site-search-box--is-expanded')) {
        event.preventDefault();
        this.collapseSearchHeader();
      }
    });

    $('.js-header-logo').on('focus', () => {
      if ($('.js-search-header').hasClass('site-search-box--is-expanded')) {
        this.collapseSearchHeader();
      }
    });

    $('.js-search-result-filter-dropdown').on('change', event => this.onMobileTabChange(event));

    if ($('.js-input-search-main').length) {
      this.searchEvents();
    }

    $('.search-page-content').on('click', '.ga-product-click, .ga4-search-result', event => {
      const searchTerm = $('.js-input-search-main').val();
      if (searchTerm) {
        this.clickOnSearchResultItem(event, searchTerm, this.calculateTotalSearchResults());
      }
    });
  }
}